/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface SettingsProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Settings: React.FC<SettingsProps> = ({ color = 'none', ...props }) => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0909 8.11209C14.0909 7.70501 14.4209 7.375 14.828 7.375H19.0694C19.4764 7.375 19.8064 7.70501 19.8064 8.11209C19.8064 8.51917 19.4764 8.84917 19.0694 8.84917H14.828C14.4209 8.84917 14.0909 8.51917 14.0909 8.11209Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19442 8.11209C4.19442 7.70501 4.52442 7.375 4.9315 7.375H7.75907C8.16615 7.375 8.49616 7.70501 8.49616 8.11209C8.49616 8.51917 8.16615 8.84917 7.75907 8.84917H4.9315C4.52442 8.84917 4.19442 8.51917 4.19442 8.11209Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5866 6.37505C9.6273 6.37505 8.8496 7.15275 8.8496 8.11209C8.8496 9.07143 9.6273 9.84913 10.5866 9.84913C11.546 9.84913 12.3237 9.07143 12.3237 8.11209C12.3237 7.15275 11.546 6.37505 10.5866 6.37505ZM7.37543 8.11209C7.37543 6.33859 8.81314 4.90088 10.5866 4.90088C12.3601 4.90088 13.7979 6.33859 13.7979 8.11209C13.7979 9.88559 12.3601 11.3233 10.5866 11.3233C8.81314 11.3233 7.37543 9.88559 7.37543 8.11209Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5047 15.887C15.5047 15.4799 15.8347 15.1499 16.2418 15.1499H19.0694C19.4764 15.1499 19.8064 15.4799 19.8064 15.887C19.8064 16.294 19.4764 16.6241 19.0694 16.6241H16.2418C15.8347 16.6241 15.5047 16.294 15.5047 15.887Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19434 15.887C4.19434 15.4799 4.52434 15.1499 4.93142 15.1499H9.17278C9.57986 15.1499 9.90986 15.4799 9.90986 15.887C9.90986 16.294 9.57986 16.6241 9.17278 16.6241H4.93142C4.52434 16.6241 4.19434 16.294 4.19434 15.887Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4142 14.1509C12.4549 14.1509 11.6772 14.9286 11.6772 15.8879C11.6772 16.8472 12.4549 17.6249 13.4142 17.6249C14.3736 17.6249 15.1513 16.8472 15.1513 15.8879C15.1513 14.9286 14.3736 14.1509 13.4142 14.1509ZM10.203 15.8879C10.203 14.1144 11.6407 12.6767 13.4142 12.6767C15.1877 12.6767 16.6254 14.1144 16.6254 15.8879C16.6254 17.6614 15.1877 19.0991 13.4142 19.0991C11.6407 19.0991 10.203 17.6614 10.203 15.8879Z"
        fill={color}
      />
    </svg>
  );
};
